import { config } from 'env_def';
import { ClientTypeEnum, } from '../../../api/logical/netStorage';
import { apis } from '../../../config';
import { api } from '../../../api/api';
import { ErrMsgCodeMap, ErrResult } from '../../../api/errMap';
const masterAuthority = { roleId: 100, roleName: '管理' };
class ActionStore {
    constructor() {
        this.uploadInfo = {};
    }
}
class NetStorageImpl {
    constructor() {
        this.name = apis.netStorageImpl;
        this.httpApi = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
        this.eventApi = api.getEventApi();
        this.actions = new ActionStore();
    }
    getFilePreviewUrl(url) {
        return this.httpApi.get(url).then(res => this.unpackRes(res));
    }
    getLinkInfo(req) {
        return this.httpApi.get(this.systemApi.getUrl('getLinkInfo'), req, { contentType: 'form' }).then(res => this.unpackRes(res));
    }
    addFavorite(req) {
        const url = this.systemApi.getUrl('addFavorite');
        return this.httpApi.post(url, req, { noErrorMsgEmit: true }).then(res => this.unpackRes(res));
    }
    removeFavorite(req) {
        const url = this.systemApi.getUrl('removeFavorite');
        return this.httpApi.post(url, req, { noErrorMsgEmit: true }).then(res => this.unpackRes(res));
    }
    getFavoriteList(req) {
        const url = this.systemApi.getUrl('getFavoriteList');
        return this.httpApi.get(url, req).then(res => this.unpackRes(res));
    }
    recoverRecords(req) {
        let url = '';
        switch (req.type) {
            case 'ent':
                url = this.systemApi.getUrl('recoverRecords');
                break;
            case 'personal':
                url = this.systemApi.getUrl('recoverPersonalRecords');
                break;
            default:
                break;
        }
        return this.httpApi.post(url, req, { noErrorMsgEmit: true });
    }
    deleteDirOrFileList(req) {
        let url = '';
        switch (req.type) {
            case 'ent':
                url = this.systemApi.getUrl('deleteDirOrFileList');
                break;
            case 'personal':
                url = this.systemApi.getUrl('deletePersonalDirOrFileList');
                break;
            default:
                break;
        }
        return this.httpApi.post(url, req).then(res => {
            const { code, message } = this.unpackRes(res);
            return {
                code,
                title: message,
            };
        });
    }
    deleteRecyRecordCompletely(req) {
        let url = '';
        switch (req.type) {
            case 'ent':
                url = this.systemApi.getUrl('deleteRecyRecordCompletely');
                break;
            case 'personal':
                url = this.systemApi.getUrl('deleteRecyPersonalRecordCompletely');
                break;
            default:
                break;
        }
        return this.httpApi.post(url, req, { contentType: 'json' });
    }
    getRecoverDirs(req) {
        let url = '';
        switch (req.type) {
            case 'personal':
                url = this.systemApi.getUrl('getPersonalRecoverDirs');
                break;
            case 'ent':
                url = this.systemApi.getUrl('getRecoverDirs');
                break;
            default:
                break;
        }
        return this.httpApi.get(url, req).then(res => this.unpackRes(res));
    }
    init() {
        return this.name;
    }
    doCreateFolder(req) {
        const url = this.getUrl(req.type, 'createNSFolder');
        return this.httpApi
            .post(url, {
            dirName: req.folderName,
            parentDirId: req.dirId,
        })
            .then(res => {
            const data = this.unpackRes(res);
            return data;
        });
    }
    doDeleteItem(req) {
        let url;
        let data;
        if (req.delType == 'folder' && req.dirId) {
            url = this.getUrl(req.type, 'delNSResource');
            data = {
                resourceId: req.dirId,
                resourceType: 'DIRECTORY',
            };
        }
        else if (req.delType == 'sub' && req.dirId) {
            url = this.getUrl(req.type, 'clearNSFolder');
            data = { dirId: req.dirId };
        }
        else if (req.delType == 'file' && req.fileId) {
            url = this.getUrl(req.type, 'delNSResource');
            data = {
                resourceId: req.fileId,
                resourceType: 'FILE',
            };
        }
        else {
            return Promise.reject('参数非法');
        }
        return this.httpApi.post(url, data).then(res => {
            const { code, message } = this.unpackRes(res);
            return {
                code,
                title: message,
            };
        });
    }
    doDeleteItems(req) {
        let url = '';
        switch (req.type) {
            case 'ent':
                url = this.systemApi.getUrl('deleteDirOrFileList');
                break;
            case 'personal':
                url = this.systemApi.getUrl('deletePersonalDirOrFileList');
                break;
            default:
                url = this.getUrl(req.type, 'delNSItems');
                break;
        }
        return this.httpApi.post(url, req, { contentType: 'json' }).then(res => {
            const unpackRes = this.unpackRes(res, true);
            return unpackRes;
        });
    }
    doDeleteCloudAtt(req) {
        const url = this.systemApi.getUrl('doDeleteCloudAtt');
        return this.httpApi.post(url, req, { contentType: 'form' }).then(res => {
            const unpackRes = this.unpackRes(res, true);
            return unpackRes;
        });
    }
    batchDeleteCloudAtt(req) {
        const url = this.systemApi.getUrl('batchDeleteCloudAtt');
        return this.httpApi.post(url, req, { contentType: 'json' }).then(res => {
            const unpackRes = this.unpackRes(res, true);
            return unpackRes;
        });
    }
    previewCloudAtt(req) {
        const url = this.systemApi.getUrl('previewCloudAtt');
        return this.httpApi.get(url, req).then(res => this.unpackRes(res));
    }
    doGetAllAuthorities(req) {
        const url = this.systemApi.getUrl('getAllAuthorities');
        return this.httpApi.get(url, req).then(res => this.unpackRes(res));
    }
    downloadCloudAtt(req) {
        const url = this.systemApi.getUrl('downloadCloudAtt');
        return this.httpApi.post(url, req, { contentType: 'form' }).then(res => {
            const unpackRes = this.unpackRes(res, true);
            return unpackRes;
        });
    }
    saveCloudAttachment(req) {
        const url = this.systemApi.getUrl('saveCloudAttachment');
        return this.httpApi.post(url, req, { contentType: 'form', noErrorMsgEmit: true }).then(res => {
            const unpackRes = this.unpackRes(res, true);
            return unpackRes;
        });
    }
    doGetNSDownloadInfo(req, mode) {
        const url = this.getUrl(req.type, mode == 'download' ? 'downloadNSFile' : 'previewNSFile');
        return this.httpApi.get(url, req).then(res => ({
            data: res.data,
        }));
    }
    doGetNSEntFolderAuthInfo(dirId) {
        console.log('[disk] get dir auth info ', dirId);
        const url = this.systemApi.getUrl(dirId === undefined ? 'getNSEntRootAuthInfo' : 'getNSEntAuthInfo');
        return this.httpApi.get(url, { dirId }).then(res => {
            const unpackRes = this.unpackRes(res);
            return unpackRes;
        });
    }
    doGetNSFileInfo(req) {
        const url = this.getUrl(req.type, 'getNSFileDetail');
        return this.httpApi.get(url, req).then(res => {
            var _a;
            const finalRes = this.unpackRes(res);
            finalRes.roleArr = req.type === 'personal' ? [masterAuthority] : ((_a = finalRes === null || finalRes === void 0 ? void 0 : finalRes.authorityDetail) === null || _a === void 0 ? void 0 : _a.roleInfos) || [];
            return finalRes;
        });
    }
    doGetNSFolderInfo(req) {
        const url = !req.dirId ? this.getUrl(req.type, 'getRootDir') : this.getUrl(req.type, 'getNSDirDetail');
        if (!req.dirId && typeof req.needVolume === 'undefined') {
            req.needVolume = true;
        }
        return this.httpApi
            .get(url, req, { cachePolicy: 'refresh' })
            .then(res => {
            var _a;
            const unpackRes = Object.assign({}, this.unpackRes(res, false, true));
            if (!req.dirId && unpackRes && unpackRes.dirId && unpackRes.dirName) {
                unpackRes.id = unpackRes.dirId;
                unpackRes.name = unpackRes.dirName;
                if (unpackRes.diskVolume) {
                    unpackRes.sizeLimit = unpackRes.diskVolume.sizeLimit;
                    unpackRes.spaceId = unpackRes.diskVolume.spaceId;
                    unpackRes.totalSize = unpackRes.diskVolume.totalSize;
                }
            }
            unpackRes.roleArr = req.type === 'personal' ? [masterAuthority] : ((_a = unpackRes === null || unpackRes === void 0 ? void 0 : unpackRes.authorityDetail) === null || _a === void 0 ? void 0 : _a.roleInfos) || [];
            return unpackRes;
        })
            .catch(err => Promise.reject(err));
    }
    doGetNSFolderSubContentNumber(req) {
        const url = this.getUrl(req.type, 'listNSContentNumber');
        return this.httpApi.get(url, req).then(res => this.unpackRes(res));
    }
    doUpdateUploadNSInfo(req) {
        const url = this.getUrl(req.type, 'renewNSUploadToken');
        return this.httpApi.post(url, req).then(res => {
            const { code, message } = this.unpackRes(res);
            return {
                code,
                title: message,
            };
        });
    }
    doGetNSUploadInfo(req, config = { timeout: 60000 * 2 }) {
        if (!req || !req.fileName || !req.dirId)
            return Promise.reject('参数有误，请验证后再试');
        const url = this.getUrl(req.type, 'getNSUploadToken');
        return this.httpApi.get(url, req, config).then(res => {
            const unpackRes = this.unpackRes(res);
            return unpackRes;
        });
    }
    doGetNSVolume(type) {
        return Promise.reject(type);
    }
    doBatchZipDownload(req) {
        const url = this.getUrl(req.type, 'batchZipDownload');
        const reqUrl = this.httpApi.buildUrl(url, req);
        if (this.systemApi.isElectron()) {
            return reqUrl;
        }
        this.systemApi.webDownloadLink(reqUrl);
    }
    doListNSContent(req, options) {
        const url = this.getUrl(req.type, 'listNSContent');
        return this.httpApi
            .get(url, req, {
            contentType: 'form',
            cachePolicy: 'refresh',
            noEnqueue: !!(options === null || options === void 0 ? void 0 : options.noEnqueue),
        })
            .then(res => {
            var _a, _b, _c;
            if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) {
                res.data.data.returnTag = req.dirId;
            }
            const finalRes = this.unpackRes(res);
            if ((_b = finalRes === null || finalRes === void 0 ? void 0 : finalRes.dirList) === null || _b === void 0 ? void 0 : _b.length) {
                finalRes.dirList = finalRes.dirList.map((item) => {
                    var _a;
                    if (req.type === 'personal')
                        return Object.assign(Object.assign({}, item), { roleArr: [masterAuthority] });
                    return Object.assign(Object.assign({}, item), { roleArr: ((_a = item === null || item === void 0 ? void 0 : item.authorityDetail) === null || _a === void 0 ? void 0 : _a.roleInfos) || [] });
                });
            }
            if ((_c = finalRes === null || finalRes === void 0 ? void 0 : finalRes.fileList) === null || _c === void 0 ? void 0 : _c.length) {
                finalRes.fileList = finalRes.fileList.map((item) => {
                    var _a;
                    if (req.type === 'personal')
                        return Object.assign(Object.assign({}, item), { roleArr: [masterAuthority] });
                    return Object.assign(Object.assign({}, item), { roleArr: ((_a = item === null || item === void 0 ? void 0 : item.authorityDetail) === null || _a === void 0 ? void 0 : _a.roleInfos) || [] });
                });
            }
            return finalRes;
        });
    }
    doMoveNSItem(req) {
        const url = this.getUrl(req.type, 'moveNSResource');
        const data = {
            tarDirId: req.distFolder,
            dirList: [],
            fileList: [],
        };
        if (req.dirList && req.dirList.length > 0) {
            data.dirList = req.dirList;
        }
        else if (req.dirId) {
            data.dirList.push(req.dirId);
        }
        if (req.fileList && req.fileList.length > 0) {
            data.fileList = req.fileList;
        }
        else if (req.fileId) {
            data.fileList.push(req.fileId);
        }
        return this.httpApi.post(url, data).then(res => {
            const { code, message } = this.unpackRes(res);
            return {
                code,
                title: message,
            };
        });
    }
    async doNSMoveDir(req) {
        const url = this.getUrl('ent', 'moveNSDir');
        return this.httpApi.post(url, req, {
            noErrorMsgEmit: true,
        });
    }
    async doAddAttachmentPersonalAsNormal(ids, _account) {
        const url = this.systemApi.getUrl('addAttachmentPersonalAsNormal');
        return this.httpApi
            .get(url, { id: ids }, {
            noErrorMsgEmit: true,
            _account,
        })
            .then(res => {
            const data = this.unpackRes(res);
            return data.map(({ fileName, internalUrl, size, id }) => ({
                id,
                fileName,
                fileSize: size,
                fileUrl: internalUrl,
                isCloud: false,
            }));
        });
    }
    async doAddAttachmentEntAsNormal(ids, _account) {
        const url = this.systemApi.getUrl('addAttachmentEntAsNormal');
        return this.httpApi
            .get(url, { id: ids }, {
            noErrorMsgEmit: true,
            _account,
        })
            .then(res => {
            const data = this.unpackRes(res);
            return data.map(({ fileName, internalUrl, size, id }) => ({
                id,
                fileName,
                fileSize: size,
                fileUrl: internalUrl,
                isCloud: false,
            }));
        });
    }
    async doAddAttachmentPersonalAsCloud(ids, _account) {
        const url = this.systemApi.getUrl('addAttachmentPersonalAsCloud');
        return this.httpApi
            .post(url, { id: ids }, {
            noErrorMsgEmit: true,
            _account,
        })
            .then(res => {
            const data = this.unpackRes(res);
            return data.map(({ fileName, expireTime, downloadUrl, fileSize, identity }, idx) => ({
                fileName,
                fileSize,
                fileUrl: downloadUrl,
                identity,
                expired: expireTime,
                isCloud: true,
                id: idx,
            }));
        });
    }
    async doAddAttachmentEntAsCloud(ids, _account) {
        const url = this.systemApi.getUrl('addAttachmentEntAsCloud');
        return this.httpApi
            .post(url, { id: ids }, {
            noErrorMsgEmit: true,
            _account,
        })
            .then(res => {
            const data = this.unpackRes(res);
            return data.map(({ fileName, expireTime, downloadUrl, fileSize, identity }, idx) => ({
                fileName,
                fileSize,
                fileUrl: downloadUrl,
                identity,
                expired: expireTime,
                isCloud: true,
                id: idx,
            }));
        });
    }
    getDirList(req) {
        const url = this.getUrl(req.type, 'getDirList');
        return this.httpApi.get(url, req, { cachePolicy: 'refresh' }).then(res => this.unpackRes(res));
    }
    doNSResourceSearch(req) {
        const url = this.getUrl(req.type, 'searchResource');
        return this.httpApi.get(url, req).then(res => this.unpackRes(res));
    }
    doSetNSUploadFinish(req) {
        const url = this.getUrl(req.type, 'uploadNSFinish');
        return this.httpApi.get(url, req).then(res => this.unpackRes(res));
    }
    finishUploadAtt(req) {
        const url = this.systemApi.getUrl('finishUploadAtt');
        return this.httpApi.post(url, req, { contentType: 'form' }).then(res => this.unpackRes(res));
    }
    initPersonalSpace() {
        return this.httpApi.get(this.systemApi.getUrl('initPersonalSpace'), {}).then(res => this.unpackRes(res));
    }
    getDirPathInfoUsingGET(req) {
        const url = this.getUrl(req.type, 'getDirPathInfoUsingGET');
        return this.httpApi.get(url, req, { cachePolicy: 'refresh' }).then(res => this.unpackRes(res));
    }
    isLockEnabledUsingGET() {
        return this.httpApi.get(this.systemApi.getUrl('isLockEnabledUsingGET'), {}).then(res => this.unpackRes(res));
    }
    saveMailAttachment(fileInfo) {
        const user = this.systemApi.getCurrentUser();
        const userInfo = {
            sid: user === null || user === void 0 ? void 0 : user.sessionId,
            uid: user === null || user === void 0 ? void 0 : user.id,
        };
        return this.httpApi.post(this.systemApi.getUrl('saveMailAttachment'), {}, { params: Object.assign(Object.assign({}, fileInfo), userInfo), noErrorMsgEmit: true }).then(res => res === null || res === void 0 ? void 0 : res.data);
    }
    doUpdateNSResource(req) {
        if (!req || (!req.description && !req.itemName) || req.dirId)
            return Promise.reject('参数不足');
        const renamePromise = req.itemName
            ? this.renameNSFile(req)
            : Promise.resolve({
                code: '0',
                title: '',
            });
        const updateFilePromise = req.description
            ? this.updateNSFileDes(req)
            : Promise.resolve({
                code: '0',
                title: '',
            });
        return Promise.all([renamePromise, updateFilePromise]).then((res) => ({
            code: res[0].code == '0' ? res[1].code : res[0].code,
            title: res[0].title ? res[0].title : res[1].title,
        }));
    }
    renameNSFile(req) {
        const { type, dirId, fileId, itemName } = req;
        const url = this.getUrl(req.type, req.fileId ? 'renameNSFile' : 'renameNSFolder');
        const data = {};
        data.type = type;
        data.dirId = String(dirId);
        if (req.fileId) {
            data.fileName = itemName || '_';
            data.fileId = String(fileId);
        }
        else {
            data.newDirName = itemName || '_';
        }
        const _req = this.httpApi.post(url, data);
        return _req.then(res => {
            const { code, message } = this.unpackRes(res);
            return {
                code,
                title: message,
            };
        });
    }
    async renameCloudAtt(req) {
        const url = this.systemApi.getUrl('renameCloudAtt');
        try {
            const res = await this.httpApi.post(url, req, { _account: (req === null || req === void 0 ? void 0 : req._account) || '', noErrorMsgEmit: true });
            const { data, status } = res;
            if (status === 200 && !!(data === null || data === void 0 ? void 0 : data.data))
                return { success: true };
            return { success: false, message: (data === null || data === void 0 ? void 0 : data.message) || '云附件重命名失败' };
        }
        catch (error) {
            const { data } = error;
            const { message, code } = data || {};
            return {
                success: false,
                message: code === 10100 ? '暂无权限进行此操作，只能修改自己的云附件' : message || '云附件重命名失败',
                code: code || '',
            };
        }
    }
    updateNSFileDes(req) {
        const url = this.getUrl(req.type, req.fileId ? 'updateNSFileDes' : 'updateNSFolderDes');
        const data = {};
        if (req.fileId) {
            data.description = req.itemName || '_';
            data.fileId = String(req.fileId);
            data.dirId = String(req.dirId);
        }
        else {
            data.dirId = String(req.dirId);
            data.description = req.itemName || '_';
        }
        return this.httpApi.post(url, data).then(res => {
            const { code, message } = this.unpackRes(res);
            return {
                code,
                title: message,
            };
        });
    }
    doSearchDirAndFileList(req) {
        return this.httpApi.get(this.systemApi.getUrl('searchDirAndFileList'), req).then(res => this.unpackRes(res));
    }
    doCreateFile(req) {
        const url = this.getUrl(req.type, 'createFile');
        return this.httpApi.post(url, req).then(res => {
            const unpackRes = this.unpackRes(res);
            return unpackRes;
        });
    }
    listNSRecently(req, options) {
        return this.httpApi
            .get(this.systemApi.getUrl('getNSRecentlyList'), req, {
            cachePolicy: 'refresh',
            noEnqueue: !!(options === null || options === void 0 ? void 0 : options.noEnqueue),
        })
            .then(res => {
            const finalRes = this.unpackRes(res);
            if (!finalRes.recentlyUseRecords)
                return finalRes;
            finalRes.recentlyUseRecords = finalRes.recentlyUseRecords.map((item) => (Object.assign(Object.assign({}, item), { roleArr: (item === null || item === void 0 ? void 0 : item.roles) || [] })));
            return finalRes;
        });
    }
    getPersonalRecycleList(req) {
        return this.httpApi.get(this.systemApi.getUrl('getPersonalRecycleList'), req).then(res => this.unpackRes(res));
    }
    getRecycleList(req) {
        let url = '';
        switch (req.type) {
            case 'personal':
                url = this.systemApi.getUrl('getPersonalRecycleList');
                break;
            case 'ent':
                url = this.systemApi.getUrl('getRecycleList');
                break;
        }
        return this.httpApi.get(url, req).then(res => this.unpackRes(res));
    }
    listDir(req) {
        const url = this.getUrl(req.type, 'listDir');
        return this.httpApi.get(url, req, { contentType: 'form' }).then(res => {
            var _a;
            const finalRes = this.unpackRes(res);
            if (!((_a = finalRes === null || finalRes === void 0 ? void 0 : finalRes.list) === null || _a === void 0 ? void 0 : _a.length))
                return finalRes;
            finalRes.list = finalRes.list.map((item) => {
                var _a;
                if (req.type === 'personal')
                    return Object.assign(Object.assign({}, item), { roleArr: [masterAuthority] });
                return Object.assign(Object.assign({}, item), { roleArr: ((_a = item === null || item === void 0 ? void 0 : item.authorityDetail) === null || _a === void 0 ? void 0 : _a.roleInfos) || [] });
            });
            return finalRes;
        });
    }
    listFile(req) {
        const url = this.getUrl(req.type, 'listFile');
        return this.httpApi.get(url, req, { contentType: 'form' }).then(res => {
            var _a;
            const finalRes = this.unpackRes(res);
            if (!((_a = finalRes === null || finalRes === void 0 ? void 0 : finalRes.list) === null || _a === void 0 ? void 0 : _a.length))
                return finalRes;
            finalRes.list = finalRes.list.map((item) => {
                var _a;
                if (req.type === 'personal')
                    return Object.assign(Object.assign({}, item), { roleArr: [masterAuthority] });
                return Object.assign(Object.assign({}, item), { roleArr: ((_a = item === null || item === void 0 ? void 0 : item.authorityDetail) === null || _a === void 0 ? void 0 : _a.roleInfos) || [] });
            });
            return finalRes;
        });
    }
    async getCloudAttList(req) {
        return this.httpApi.get(this.systemApi.getUrl('getCloudAttList'), req).then(res => this.unpackRes(res));
    }
    async getCloudAtt(req) {
        return this.httpApi.get(this.systemApi.getUrl('getCloudAttList'), req).then(res => this.unpackRes(res));
    }
    async renewAttachments(req) {
        return this.httpApi.post(this.systemApi.getUrl('renewAttachments'), req, { contentType: 'json' }).then(res => this.unpackRes(res));
    }
    async getExpiringFileCount() {
        return this.httpApi.get(this.systemApi.getUrl('getExpiringFileCount')).then(res => this.unpackRes(res));
    }
    deleteNSRecord(req) {
        return this.httpApi.post(this.systemApi.getUrl('deleteUseRecord'), req).then(res => this.unpackRes(res));
    }
    getNSRecordDownloadUrl(req) {
        return this.httpApi.get(this.systemApi.getUrl('getUseRecordDownloadUrl'), req).then(res => this.unpackRes(res));
    }
    getNewUserAnnouncement(req) {
        const data = req || {
            clientType: ClientTypeEnum.DESK_TOP,
            clientVersion: config('version'),
        };
        return this.httpApi.get(this.systemApi.getUrl('getNewUserAnnouncement'), data).then(res => this.unpackRes(res));
    }
    operateAnnouncement(req) {
        return this.httpApi.post(this.systemApi.getUrl('operateAnnouncement'), req, { contentType: 'json' }).then(res => this.unpackRes(res));
    }
    getDocTemplateList() {
        return this.httpApi.get(this.systemApi.getUrl('getDocTemplateList')).then(res => this.unpackRes(res));
    }
    createTemplate(req) {
        return this.httpApi.post(this.systemApi.getUrl('createTemplate'), req).then(res => this.unpackRes(res));
    }
    deleteTemplate(req) {
        return this.httpApi.delete(this.systemApi.getUrl('deleteTemplate'), req).then(res => this.unpackRes(res));
    }
    checkCreateUnitableAvailable() {
        return this.httpApi
            .get(this.systemApi.getUrl('queryCreateType'))
            .then(res => this.unpackRes(res))
            .then(res => res && res.unitable);
    }
    appIsEnable() {
        return this.httpApi.get(this.systemApi.getUrl('appIsEnable')).then(res => this.unpackRes(res));
    }
    getUserApp(req) {
        return this.httpApi.get(this.systemApi.getUrl('getUserApp'), req).then(res => this.unpackRes(res));
    }
    getUniTradeURL(req) {
        return this.httpApi.post(this.systemApi.getUrl('getUniTradeURL'), req).then(res => this.unpackRes(res));
    }
    getNewUniTradeURL(req) {
        return this.httpApi.post(this.systemApi.getUrl('getNewUniTradeURL'), req).then(res => this.unpackRes(res));
    }
    getUniCustomerId(req) {
        return this.httpApi.post(this.systemApi.getUrl('getUniCustomerId'), req, { contentType: 'json' }).then(res => this.unpackRes(res));
    }
    getUniFieldMapping(req) {
        return this.httpApi.get(this.systemApi.getUrl('getUniFieldMapping'), req).then(res => this.unpackRes(res));
    }
    getFieldMapping(req) {
        return this.httpApi.get(this.systemApi.getUrl('getFieldMapping'), req).then(res => this.unpackRes(res));
    }
    createPersonalDocByTemplate(req) {
        return this.httpApi.post(this.systemApi.getUrl('createPersonalDocByTemplate'), req).then(res => this.unpackRes(res));
    }
    createDocByTemplate(req) {
        return this.httpApi.post(this.systemApi.getUrl('createDocByTemplate'), req).then(res => this.unpackRes(res));
    }
    getApplyInfo(req) {
        return this.httpApi.get(this.systemApi.getUrl('getApplyInfo'), req).then(res => this.unpackRes(res));
    }
    getApplyStatus(req) {
        return this.httpApi.get(this.systemApi.getUrl('getApplyStatus'), req).then(res => this.unpackRes(res));
    }
    applyAuth(req) {
        return this.httpApi.post(this.systemApi.getUrl('applyAuth'), req, { contentType: 'json' }).then(res => this.unpackRes(res));
    }
    getAnnouncement(req) {
        return this.httpApi.get(this.systemApi.getUrl('getAnnouncement'), req).then(res => this.unpackRes(res));
    }
    feedBackNps(req) {
        return this.httpApi.post(this.systemApi.getUrl('feedBackNps'), req, { contentType: 'json' }).then(res => this.unpackRes(res));
    }
    getLinkInfoBatch(req) {
        return this.httpApi.post(this.systemApi.getUrl('getLinkInfoBatch'), req, { contentType: 'form' }).then(res => this.unpackRes(res));
    }
    getUrl(type, key) {
        const typeKeyMap = {
            ent: key,
            personalShare: key + 'PS',
            personal: key + 'P',
            cloudAtt: key + 'CA',
            favorites: key + 'FA',
        };
        const urlKey = typeKeyMap[type] || key;
        return this.systemApi.getUrl(urlKey);
    }
    unpackRes(res, returnWhole, returnErrorAsIs) {
        console.log('[disk] from network:', res);
        if (returnWhole) {
            return res.data;
        }
        if (res && res.data && res.data.success) {
            return res.data.data;
        }
        if (res && res.data) {
            if (returnErrorAsIs)
                return res.data;
            return this.getNSErrMsg(res.data);
        }
        return Promise.reject(NetStorageImpl.defaultErrInfo);
    }
    commonCatch(reason) {
        console.warn('[disk] error :', reason);
        if (reason instanceof Error)
            return this.getErrMsg(reason.message);
        if (typeof reason === 'string')
            return this.getErrMsg(reason);
        return NetStorageImpl.defaultErrInfo;
    }
    getNSErrMsg(err) {
        if (err && err.code) {
            return this.getErrMsg(err.code);
        }
        return {
            code: err.code === undefined ? '' : err.code + '',
            title: err.message || ErrMsgCodeMap.UNKNOWN_ERR,
        };
    }
    getErrMsg(errMsg, defaultMsg) {
        if (errMsg) {
            const messageInfo = ErrResult[errMsg];
            if (messageInfo) {
                if ((messageInfo.popupType && messageInfo.popupType == 'window') || messageInfo.popupType == 'toast') {
                    this.eventApi.sendSysEvent({
                        eventName: 'error',
                        eventLevel: 'error',
                        eventStrData: '',
                        eventData: messageInfo,
                        eventSeq: 0,
                    });
                }
                return messageInfo;
            }
            if (errMsg in ErrMsgCodeMap) {
                return {
                    title: ErrMsgCodeMap[errMsg],
                    code: errMsg + '',
                };
            }
        }
        return {
            title: (errMsg ? errMsg + '' : undefined) || defaultMsg || ErrMsgCodeMap.UNKNOWN_ERR,
            code: 'UNKNOWN_ERR',
        };
    }
    afterLogin() {
        this.actions = new ActionStore();
        return this.name;
    }
}
NetStorageImpl.defaultErrInfo = {
    popupType: 'window',
    title: ErrMsgCodeMap['SERVER.ERR'],
    code: 'SERVER.ERR',
};
const netStorageImpl = new NetStorageImpl();
api.registerLogicalApi(netStorageImpl);
export default netStorageImpl;
